export default __webpack_public_path__ + "static/media/finextra-logo.816a6c02.png";